"use strict";

var communityPosts = document.querySelector(".js-community-posts");
var eventsContainer = document.querySelector(".js-events-home");

// ─── Paw state tracking ─────────────────────────────────────────────────────
// Tracks pawed state across tab switches. Seeded from server, updated on click.
// Keys are "Type:id" strings (e.g. "News:123", "Event:456").

var pawedState = {};

function pawKey(type, id) {
  return type + ":" + id;
}

function seedPawedState() {
  var serverIds = window.__communityPawedIds;
  if (!Array.isArray(serverIds)) return;

  serverIds.forEach(function (entry) {
    pawedState[pawKey(entry.type, entry.id)] = true;
  });
}

// ─── Paw button handling ─────────────────────────────────────────────────────

function pawLabel(action, button, count) {
  var title = button.dataset.thingTitle;
  var subject = title || ("this " + (button.dataset.thingType === "Event" ? "event" : "post"));
  return action + " " + subject + ", " + count + (count === 1 ? " paw" : " paws");
}

function applyPawedState() {
  var containers = [communityPosts, eventsContainer].filter(Boolean);

  containers.forEach(function (container) {
    container.querySelectorAll(".js-paw-button").forEach(function (button) {
      var id = parseInt(button.dataset.thingId, 10);
      var type = button.dataset.thingType;
      var key = pawKey(type, id);

      if (pawedState[key]) {
        var countEl = button.closest(".start-community__post-actions-left").querySelector(".js-paw-count");
        var count = Math.max(1, parseInt(countEl.textContent.replace(/,/g, ""), 10));
        countEl.textContent = count.toLocaleString() + (count === 1 ? " paw" : " paws");
        button.setAttribute("aria-pressed", "true");
        button.classList.add("js-paw-button--pawed");
        button.setAttribute("aria-label", pawLabel("Unpaw", button, count));
      }
    });
  });
}

function doPawClick(evt) {
  var button = evt.target.closest(".js-paw-button");
  if (!button || button.classList.contains("js-paw-button--loading")) {
    return;
  }

  var pawed = button.getAttribute("aria-pressed") === "true";
  var baseUrl = pawed ? button.dataset.unpawUrl : button.dataset.pawUrl;
  var thingType = button.dataset.thingType;
  var url = baseUrl;
  var method = pawed ? "DELETE" : "POST";
  var countEl = button.closest(".start-community__post-actions-left").querySelector(".js-paw-count");
  var count = parseInt(countEl.textContent.replace(/,/g, ""), 10);
  var contentId = parseInt(button.dataset.thingId, 10);

  button.classList.add("js-paw-button--loading");

  var xhr = new XMLHttpRequest();
  xhr.open(method, url);
  xhr.setRequestHeader("X-Requested-With", "XMLHttpRequest");
  xhr.setRequestHeader("Content-Type", "application/json");
  var csrfToken = document.querySelector("meta[name=csrf-token]");
  if (csrfToken) {
    xhr.setRequestHeader("X-CSRF-Token", csrfToken.getAttribute("content"));
  }

  xhr.onload = function () {
    if (xhr.status === 401) {
      window.location.href = "/login";
      return;
    }

    if (xhr.status === 200) {
      var newPawed = !pawed;
      button.setAttribute("aria-pressed", newPawed ? "true" : "false");
      button.classList.toggle("js-paw-button--pawed", newPawed);
      var newCount = newPawed ? count + 1 : count - 1;
      countEl.textContent = newCount.toLocaleString() + (newCount === 1 ? " paw" : " paws");
      button.setAttribute("aria-label", pawLabel(newPawed ? "Unpaw" : "Paw", button, newCount));

      // Track the state change so it persists across tab switches
      var key = pawKey(thingType, contentId);
      if (newPawed) {
        pawedState[key] = true;
      } else {
        delete pawedState[key];
      }

      // Update the tab cache with current DOM so counts stay correct on tab switch
      if (activeTab && communityPosts) {
        tabCache[activeTab] = communityPosts.innerHTML;
      }
    }
    setTimeout(function () {
      button.classList.remove("js-paw-button--loading");
    }, 500);
  };

  xhr.onerror = function () {
    setTimeout(function () {
      button.classList.remove("js-paw-button--loading");
    }, 500);
  };

  xhr.send();
}

// ─── Tab switching ───────────────────────────────────────────────────────────

var activeTab = null;
var tabCache = {};

function switchTab(tab) {
  if (tab === activeTab) return;
  if (!communityPosts) return;

  var tabs = document.querySelectorAll(".js-community-tab");
  tabs.forEach(function (t) {
    var isActive = t.dataset.tab === tab;
    t.classList.toggle("start-community__nav-tab--active", isActive);
    t.setAttribute("aria-selected", isActive ? "true" : "false");
    t.setAttribute("tabindex", isActive ? "0" : "-1");
  });

  communityPosts.setAttribute("aria-labelledby", "community-tab-" + tab);

  activeTab = tab;

  // Use cached HTML if available
  if (tabCache[tab]) {
    communityPosts.innerHTML = tabCache[tab];
    applyPawedState();
    return;
  }

  communityPosts.classList.add("start-community__posts--loading");
  communityPosts.setAttribute("aria-busy", "true");

  var xhr = new XMLHttpRequest();
  xhr.open("GET", "/community/posts?tab=" + encodeURIComponent(tab));
  xhr.setRequestHeader("X-Requested-With", "XMLHttpRequest");

  xhr.onload = function () {
    communityPosts.classList.remove("start-community__posts--loading");
    communityPosts.removeAttribute("aria-busy");
    if (xhr.status === 200) {
      tabCache[tab] = xhr.responseText;
      communityPosts.innerHTML = xhr.responseText;
      applyPawedState();
    }
  };

  xhr.onerror = function () {
    communityPosts.classList.remove("start-community__posts--loading");
    communityPosts.removeAttribute("aria-busy");
  };

  xhr.send();
}

// ─── Init ────────────────────────────────────────────────────────────────────

if (eventsContainer) {
  seedPawedState();
  eventsContainer.addEventListener("click", doPawClick);
  applyPawedState();

  // Add tooltips to truncated event titles
  eventsContainer.querySelectorAll(
    ".events-home__featured-primary-title, .events-home__featured-secondary-title, .events-home__section-event-title"
  ).forEach(function (el) {
    if (el.scrollHeight > el.clientHeight) {
      el.setAttribute("data-tooltip", el.textContent.trim());
      el.classList.add("js-ui-tooltip");
    }
  });
  if (window.ui && window.ui.initTooltips) {
    window.ui.initTooltips();
  }
}

if (communityPosts) {
  seedPawedState();
  communityPosts.addEventListener("click", doPawClick);
  applyPawedState();

  activeTab = "pawpular";

  document.querySelectorAll(".js-community-tab").forEach(function (tab) {
    tab.addEventListener("click", function () {
      switchTab(tab.dataset.tab);
    });
  });

  // Arrow key navigation for tabs (APG roving tabindex pattern)
  var tablist = document.querySelector("[role='tablist']");
  if (tablist) {
    tablist.addEventListener("keydown", function (evt) {
      var tabs = Array.from(document.querySelectorAll(".js-community-tab"));
      var current = tabs.indexOf(document.activeElement);
      if (current === -1) return;

      var next;
      if (evt.key === "ArrowRight") {
        next = (current + 1) % tabs.length;
      } else if (evt.key === "ArrowLeft") {
        next = (current - 1 + tabs.length) % tabs.length;
      } else if (evt.key === "Home") {
        next = 0;
      } else if (evt.key === "End") {
        next = tabs.length - 1;
      } else {
        return;
      }

      evt.preventDefault();
      tabs[next].focus();
      switchTab(tabs[next].dataset.tab);
    });
  }
}
